module.exports = __webpack_public_path__ + "static/media/xo-diem.cc1d5956.png";